import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";

const isCsvFile = (file) => {
  const fileType = /.csv/;

  return file.type.match(fileType);
};

class Uploader {
  constructor(file, url, onComplete) {
    this.upload = new DirectUpload(file, url, this);
    this.onComplete = onComplete;
  }

  uploadFile() {
    this.upload.create((error, blob) => {
      if (error) {
        // Handle the error
      } else {
        this.onComplete(blob);
      }
    });
  }
}

export default class extends Controller {
  static targets = ["input", "inputHidden"];

  csvFileTemplate;

  initialize() {
    this.uploadFile = this.uploadFile.bind(this);
  }

  csvFileTemplateTargetConnected() {
    this.csvFileTemplate = this.csvFileTemplateTarget.dataset.template;
  }

  handleChange() {
    Array.from(this.inputTarget.files)
      .filter(isCsvFile)
      .forEach(this.uploadFile);
  }

  uploadFile(file) {
    const url = this.inputTarget.dataset.directUploadUrl;
    const inputHidden = this.inputHiddenTarget;
    const upload = new Uploader(file, url, (blob) => {
      inputHidden.value = blob.signed_id;
      inputHidden.id = `${blob.checksum}_${
        Math.floor(Math.random() * 100000) + 1
      }`;
    });
    upload.uploadFile();
  }
}
